
























import Vue from 'vue';
import store from '../store/store';
import {
  mapState,
  mapActions
} from 'vuex';

export default Vue.extend({
  name: 'NavMenu',
  data() {
    return {
      accountType: ''
    };
  },
  computed: mapState({
    menuIndex: (state: any) => store.getters.getMenuIndex,
    cacheMenu: (state: any) => store.getters.getCacheMenu,
    userInfo: (state: any) => store.getters.getUserInfo,
    menuIsCollapse: (state: any) => store.getters.getMenuIsCollapse
  }),
  methods: {
    // 菜单导航
    handleSelect(url: any) {
      if (url !== null) {
        this.$router.push({
          path: '/' + url
        });
      }
    },
    handleChangeFold() {
      this.$store.dispatch('setMenuIsCollapse', !this.menuIsCollapse);
    },
  },
  mounted() {
    this.accountType = this.userInfo.accountType;
  }
});
